module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/exportData.c77d2b67.svg";